"use strict";

var _regeneratorRuntime = require("/home/ubuntu/new/df-fronent/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/home/ubuntu/new/df-fronent/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/ubuntu/new/df-fronent/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var Razorpay = /*#__PURE__*/function () {
  function Razorpay(options) {
    _classCallCheck(this, Razorpay);

    this.options = options;
    if (typeof window !== "undefined") this.rzrpayInstannce = new window.Razorpay(this.options);
  }

  _createClass(Razorpay, [{
    key: "on",
    value: function on(event, callback) {
      this.rzrpayInstannce.on(event, callback);
    }
  }, {
    key: "open",
    value: function open() {
      this.rzrpayInstannce.open();
    }
  }]);

  return Razorpay;
}();

var useRazorpay = function useRazorpay() {
  /* Constants */
  var RAZORPAY_SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";
  var isClient = (0, react_1.useMemo)(function () {
    return typeof window !== "undefined";
  }, []);
  var checkScriptLoaded = (0, react_1.useCallback)(function () {
    if (!isClient || !("Razorpay" in window)) return false;
    return true;
  }, []);
  var loadScript = (0, react_1.useCallback)(function (scriptUrl) {
    if (!isClient) return; // Don't execute this function if it's rendering on server side

    return new Promise(function (resolve, reject) {
      var scriptTag = document.createElement("script");
      scriptTag.src = scriptUrl;

      scriptTag.onload = function (ev) {
        return resolve(ev);
      };

      scriptTag.onerror = function (err) {
        return reject(err);
      };

      document.body.appendChild(scriptTag);
    });
  }, []);
  (0, react_1.useEffect)(function () {
    if (!checkScriptLoaded()) {
      (function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return loadScript(RAZORPAY_SCRIPT);

                case 3:
                  _context.next = 8;
                  break;

                case 5:
                  _context.prev = 5;
                  _context.t0 = _context["catch"](0);
                  throw new Error(_context.t0);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 5]]);
        }));
      })();
    }
  }, []);
  return Razorpay;
};

exports.default = useRazorpay;